import { render } from "./TSVG.vue?vue&type=template&id=417b31f6"
import script from "./TSVG.vue?vue&type=script&lang=js"
export * from "./TSVG.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__